import type { ProductivityGoalResponse } from 'api/__GENERATED';
import { apiUtility, domainUtility } from 'utility';

import { toProductivityGoal } from './toProductivityGoal';

// Builds a normalized `Data.ProductivityTarget` domain from a flat list of
// ProductivityGoal DTOs. Goals whose `validFrom` is null are skipped —
// `toProductivityGoal` returns undefined for those and we guard before
// mutate-adding to keep the domain free of half-formed targets.
function toProductivityGoalDomain(args: { dtos: ProductivityGoalResponse[] }) {
  const { dtos } = args;

  const productivityTargetDomain: NormalizedDomain<Data.ProductivityTarget> = {
    allIds: [],
    byId: {},
  };

  apiUtility.iterator({
    list: dtos,
    transformer: (item) => {
      const productivityTarget = toProductivityGoal(item);
      if (productivityTarget === undefined) return;
      domainUtility.mutateAdd(productivityTargetDomain, productivityTarget);
    },
  });

  return { productivityTargetDomain };
}

export { toProductivityGoalDomain };
